// extracted by mini-css-extract-plugin
module.exports = {"layer":"SearchLayer_layer__rlXTy","searchArea":"SearchLayer_searchArea__pTZUd","searchContainer":"SearchLayer_searchContainer__2imLv"};